import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=3adf8a9f&scoped=true&"
import script from "./TableCard.vue?vue&type=script&lang=js&"
export * from "./TableCard.vue?vue&type=script&lang=js&"
import style0 from "./TableCard.vue?vue&type=style&index=0&id=3adf8a9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf8a9f",
  null
  
)

export default component.exports